import { useFlag } from '@calendly/feature-check-react'

import {
  APP_SHELL_FLAG_KEY,
  SETTINGS_IA_FLAG_KEY,
  UI_THEME_FLAG_KEY,
} from '../shell_layout/shellConstants'

/**
 * True when the user is in the frozen alpha cohort (any `ap_rebrand_*` flag).
 * No new alpha enrollments — beta users enter via `ap_product_refresh_2026_global` instead.
 *
 * Alpha users still pass `useProductRefreshBetaGate()` before experiences activate.
 * Controls dev-tool visibility for theme selector and QA debug controls.
 */
export function useProductRefreshAlphaEnabled(): boolean {
  const hasAppShellFlag = useFlag(APP_SHELL_FLAG_KEY, false)
  const hasUiThemeFlag = useFlag(UI_THEME_FLAG_KEY, false)
  const hasSettingsIaFlag = useFlag(SETTINGS_IA_FLAG_KEY, false)

  return hasAppShellFlag || hasUiThemeFlag || hasSettingsIaFlag
}
